import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Dashboard.css'


const CustomerLogin = () => {
	const [step, setStep] = useState(1);
	const [phone, setPhone] = useState("");
	const [otp, setOtp] = useState("");
	const [timer, setTimer] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [errors, setErrors] = useState({});
	const navigate = useNavigate();
	const location = useLocation();
	const redirectTo = location.state?.from || '/main';

	useEffect(() => {
		let interval;
		if (timer > 0) interval = setInterval(() => setTimer(prev => prev - 1), 1000);
		return () => clearInterval(interval);
	}, [timer]);

	const getOrGenerateDeviceId = () => {
		let deviceId = localStorage.getItem('deviceId');
		if (!deviceId) {
			// Use crypto.randomUUID() for modern browsers
			deviceId = window.crypto.randomUUID ? window.crypto.randomUUID() : 'manual-fallback-uuid-' + Date.now();
			localStorage.setItem('deviceId', deviceId);
		}
		return deviceId;
	};

	const handleSendOtp = async (e) => {
		e.preventDefault();
		setErrors({});
		setIsLoading(true);
		setOtp("");

		try {
			// 1. Check if customer exists
			const formattedPhone = `+91${phone}`;
			const checkRes = await fetch(`/api/v1/customer/find?phone=${encodeURIComponent(formattedPhone)}`);

			if (!checkRes.ok) {
				setErrors({ phone: "Account not found. Go for Registeration" });
				// Delay redirect so user can read the message
				//setTimeout(() => navigate('/register-customer'), 2500);
				return;
			}

			// 2. Customer exists, send OTP
			const otpRes = await fetch('/api/v1/auth/otp/sendV2', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ phone: formattedPhone, purpose: "LOGIN" })
			});

			if (otpRes.ok) {
				let customer = await otpRes.json();
				localStorage.setItem('customer', JSON.stringify(customer))
				setStep(2);
				setTimer(30);
			} else {
				setErrors({ phone: "Failed to send OTP. Try again later." });
			}
		} catch (err) {
			setErrors({ general: "Network error. Check connection." });
		} finally {
			setIsLoading(false);
		}
	};

	const handleVerifyOtp = async (e) => {
		e.preventDefault();
		const formattedPhone = `+91${phone}`;
		setIsLoading(true);
		try {
			const deviceId = getOrGenerateDeviceId();
			const response = await fetch('/api/v1/auth/otp/verify', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'X-Device-Id': deviceId },
				body: JSON.stringify({ phone: formattedPhone, otp, purpose: "LOGIN", allAccepted: true })
			});

			if (response.ok) {
				const data = await response.json();
				localStorage.setItem('customerAccessToken', data.accessToken);
				localStorage.setItem('customerRefreshToken', data.refreshToken);

				navigate(redirectTo, { replace: true });
			} else {
				const data = await response.json();
				setErrors({ otp: data.message });
			}
		} catch (err) {
			setErrors({ general: "Verification failed." });
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="registration-container">
			<form onSubmit={step === 1 ? handleSendOtp : handleVerifyOtp} className="registration-form">

				<h2>Customer Login</h2>
				{errors.phone && <div className="error-banner">{errors.phone}</div>}
				{errors.general && <div className="error-banner">{errors.general}</div>}

				{step === 1 ? (
					<>
						<div className="phone-input-group">
							<span>+91</span>
							<input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required minLength="10" maxLength="10" />
						</div>
						<button type="submit" disabled={isLoading || timer > 0} className="submit-btn">
							{isLoading ? "Checking..." : timer > 0 ? `Wait ${timer}s` : "Login"}
						</button>
					</>
				) : (
					<>
						<div className="form-group">
							<label>Enter 6-Digit OTP</label>
							<input type="text" value={otp} onChange={(e) => setOtp(e.target.value)} minLength="6" maxLength="6" required />
							{errors.otp && <span className="error-text">{errors.otp}</span>}
						</div>
						<button type="submit" disabled={isLoading} className="submit-btn">Verify & Login</button>
						<p onClick={() => setStep(1)} className="resend-link">Change Number/Resend OTP</p>
					</>
				)}
				<p style={{ textAlign: 'right', marginTop: '15px' }}>
					New User?<span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => navigate("/register-customer")}>Register here </span>
				</p>
			</form>
		</div>
	);
};
export default CustomerLogin;
